import { IThietLapChuanDauRaActionTypes } from "../../action-types/xet-chung-chi/IThietLapChuanDauRaActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThietLapChuanDauRaReducer } from "../../reducer-model/xet-chung-chi/IThietLapChuanDauRaReducer";

const iniState: IThietLapChuanDauRaReducer = {
    status: eReducerStatusBase.is_not_initialization,
    selectedLoaiChungChi: 0,
    ctdtSelectedIds: [],
    filterCTDT: {
        id_he: 0,
        khoa_hoc: 0
    },
    isShowGanMonChungChiModal: false,
    id_dts_gan_mon_chung_chi: [],
}

export const thietLapChuanDauRaReducer = (state: IThietLapChuanDauRaReducer = iniState, action: IThietLapChuanDauRaActionTypes): IThietLapChuanDauRaReducer => {
    switch (action.type) {
        case "THIET_LAP_CHUAN_DAU_RA_CHANGE_SELECTED_LOAI_CHUNG_CHI":
            return {
                ...state,
                selectedLoaiChungChi: action.payload
            }
        case "THIET_LAP_CHUAN_DAU_RA_CHANGE_SELECTED_CTDT_IDS":
            return {
                ...state,
                ctdtSelectedIds: action.payload
            }
        case "THIET_LAP_CHUAN_DAU_RA_CHANGE_FILTER_CTDT":
            return {
                ...state,
                filterCTDT: action.payload
            }
        case "THIET_LAP_CHUAN_DAU_RA_SHOW_GAN_MON_CHUNG_CHI_MODAL":
            return {
                ...state,
                isShowGanMonChungChiModal: true,
                id_dts_gan_mon_chung_chi: action.payload
            }
        case "THIET_LAP_CHUAN_DAU_RA_CLOSE_GAN_MON_CHUNG_CHI_MODAL":
            return {
                ...state,
                isShowGanMonChungChiModal: false,
                id_dts_gan_mon_chung_chi: []
            }
        default:
            return state;
    }
}